import styled from "styled-components";
import {
  DARK_GRAY,
  DARKER_GRAY,
  EARTH_GREEN,
  LIGHT_GRAY,
  RUBIK,
  SKY_BLUE,
  WHITE,
} from "../../index.style.ts";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 30px 0;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: ${RUBIK};
`;

export const Intro = styled.p`
  margin: 0;
  color: ${DARK_GRAY};
  line-height: 1.5;
`;

export const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media only screen and (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

export const Stat = styled.div`
  background: ${WHITE};
  border: 1px solid ${LIGHT_GRAY};
  border-radius: 12px;
  padding: 16px;

  .label {
    font-size: 13px;
    color: ${DARK_GRAY};
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .value {
    font-size: 24px;
    font-family: ${RUBIK};
    color: ${DARKER_GRAY};
  }
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 110px 1fr 120px 100px 90px;
  align-items: center;
  gap: 12px;
  background: ${WHITE};
  border: 1px solid ${LIGHT_GRAY};
  border-radius: 10px;
  padding: 12px 14px;

  @media only screen and (max-width: 800px) {
    grid-template-columns: 1fr 1fr;
  }

  .amount {
    font-family: ${RUBIK};
    color: ${DARKER_GRAY};
  }

  .badge {
    justify-self: start;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 999px;
    color: ${WHITE};
    background: ${EARTH_GREEN};
  }

  .badge.expected {
    background: ${SKY_BLUE};
  }

  .actions {
    display: flex;
    gap: 6px;
    justify-content: flex-end;
  }
`;

export const Empty = styled.div`
  background: ${WHITE};
  border: 1px dashed ${LIGHT_GRAY};
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  color: ${DARK_GRAY};
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 13px;
    color: ${DARK_GRAY};
  }

  input,
  select {
    font-family: inherit;
    font-size: 15px;
    padding: 8px 10px;
    border: 1px solid ${LIGHT_GRAY};
    border-radius: 8px;
  }

  .row {
    display: flex;
    gap: 12px;

    label {
      flex: 1;
    }
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }

  .error {
    color: #ef5350;
    font-size: 13px;
  }
`;
